import { LoadingButton } from '@mui/lab';
import { Button, Stack } from '@mui/material';
import { SingleTransaction } from 'api/payments/transactions.types';
import { PAYMENT_TYPES, STATUSES } from 'appConstants';
import AuthorizationGate from 'components/authorization-gate/authorization-gate.component';
import { useGlobalDrawer } from 'components/drawers/global-drawer/global-drawer.hooks';
import UtilityDrawerFooter from 'components/drawers/utility-drawer/utility-drawer-footer/utility-drawer-footer.component';
import { useSendReceipt } from 'pages/payments/transactions/transactions-data-grid/useSendReceipt.hooks';
import { useTranslation } from 'react-i18next';

type ButtonSectionProps = {
  transaction?: SingleTransaction;
};

const ButtonsSection = ({ transaction }: ButtonSectionProps) => {
  const { open } = useGlobalDrawer('globalRefundTransactionDrawer');

  const { t } = useTranslation();

  const { trigger, isFetching } = useSendReceipt(transaction ?? {});

  if (transaction?.type === PAYMENT_TYPES.SCAN_TO_PAY) return null;

  return (
    <UtilityDrawerFooter>
      <Stack spacing={1}>
        <AuthorizationGate permission="REFUND_ORDERS">
          <Button
            fullWidth
            disabled={[STATUSES.REFUNDED, STATUSES.FAILED].includes(
              transaction?.status,
            )}
            onClick={() => open(transaction.transactionId)}
            data-testid="PaymentDetailsDrawer.Button.Refund"
          >
            {t('drawer.transactionDrawer.buttons.refund')}
          </Button>
        </AuthorizationGate>

        <LoadingButton
          fullWidth
          onClick={trigger}
          variant="outlined"
          data-testid="PaymentDetailsDrawer.Button.SendReceipt"
          loading={isFetching}
        >
          {t('drawer.transactionDrawer.buttons.sendReceipt')}
        </LoadingButton>
      </Stack>
    </UtilityDrawerFooter>
  );
};

export default ButtonsSection;
